import type { RegistryOverview, RegistryQuery } from '../types/registry'
import { fetchApi } from './api'

/**
 * The Report Registry — ObservatoryRegistryController, LighthouseAdmin at class
 * level, GET only.
 *
 * Through the shared `fetchApi`, so a failure arrives as an ApiError carrying its
 * status: a page can tell a 403 (RestrictedState) from a 400 (an unknown status or
 * workspace, which the server refuses rather than answering with an empty page)
 * from a 500, and it can only do that by status.
 */

const BASE = '/api/observatory/registry'

/** Trimmed, or null when there is nothing left: a blank asks no question. */
function present(value: string | null | undefined): string | null {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

export function getRegistry(query: RegistryQuery = {}): Promise<RegistryOverview> {
  const params = new URLSearchParams()

  // Only filters that were actually set, trimmed. The server already treats a
  // blank as absent, so this changes no answer; it keeps the request line saying
  // only what was asked, which is what a reader of the network tab sees.
  if (query.skip != null) params.set('skip', String(query.skip))
  if (query.top != null) params.set('top', String(query.top))

  const workspaceId = present(query.workspaceId)
  if (workspaceId) params.set('workspaceId', workspaceId)

  const status = present(query.status)
  if (status) params.set('status', status)

  const owner = present(query.owner)
  if (owner) params.set('owner', owner)

  const search = present(query.search)
  if (search) params.set('search', search)

  const qs = params.toString()
  return fetchApi<RegistryOverview>(`${BASE}${qs ? `?${qs}` : ''}`)
}
